import { Box, SxProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StrengthWeaknessGroup } from '../../StrengthWeaknessGroup';
import { StrengthWeaknessItem } from '../performanceDrawerData';
import { pxToRem } from '@geneo2-web/shared-ui';

const drawerStyles = {
  card: {
    backgroundColor: '#fff',
    // boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
};
export const StrengthWeaknessSection = ({
  strengths,
  weaknesses,
  mode = 'overall',
  cardHeadingSx = {},
}: {
  strengths?: StrengthWeaknessItem[];
  weaknesses?: StrengthWeaknessItem[];
  mode?: 'overall' | 'session';
  cardHeadingSx?: SxProps;
}) => {
  const { t } = useTranslation();
  return (
    <Box sx={drawerStyles.card}>
      {/* HEADER */}
      <Box sx={drawerStyles.cardHeader}>
        <Typography>💡</Typography>
        <Typography
          variant="cardText"
          sx={{
            fontFamily: 'Poppins',
            color: '#1e293b',
            ...cardHeadingSx,
          }}
        >
          {mode === 'session'
            ? t('PAL_SW_TITLE_SESSION')
            : t('PAL_SW_TITLE_OVERALL')}
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        gap={pxToRem(10)}
        mt={pxToRem(14)}
      >
        <StrengthWeaknessGroup
          title={t('PAL_SW_STRENGTHS')}
          icon="💪"
          items={strengths}
          variant="strengths"
          emptyState={t('PAL_SW_EMPTY_STRENGTHS')}
        />

        <StrengthWeaknessGroup
          title={t('PAL_SW_NEEDS_IMPROVEMENT')}
          icon="🎯"
          items={weaknesses}
          variant="weaknesses"
          emptyState={t('PAL_SW_EMPTY_WEAKNESSES')}
        />
      </Box>
    </Box>
  );
};
